/* eslint-disable */
import createIcon from '../createIcon';

const IconMedia = createIcon({
  name: 'icon-media',
  content: '<title>ic_多媒体</title><defs><rect id="icon-media-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1655.000000, -6656.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(113.000000, 487.000000)"><g transform="translate(1044.000000, 0.000000)"><mask id="icon-media-b" fill="currentColor"><use xlink:href="#icon-media-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-media-a"/><path d="M13,3 L13,5.5 L16,4 L16,12 L13,10.5 L13,13 L0,13 L0,3 L13,3 Z M12,4 L1,4 L1,12 L12,12 L12,9 L15,10.5 L15,5.5 L12,7 L12,4 Z M6,6 L6,7 L3,7 L3,6 L6,6 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-media-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconMedia;
